import { render } from "./Foodwaste.vue?vue&type=template&id=26e2f879&scoped=true"
import script from "./Foodwaste.vue?vue&type=script&lang=js"
export * from "./Foodwaste.vue?vue&type=script&lang=js"

import "./Foodwaste.vue?vue&type=style&index=0&id=26e2f879&lang=scss&scoped=true"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-26e2f879"]])

export default __exports__